import React from 'react';
import Banner from '../Components/Banner';
import { Link } from 'react-router-dom';

const InfoCard = ({ icon, title, children }) => (
    <div className="service-card-v2 tmponhover h-full">
        <h2 className="service-card-num">
            <span>{icon}</span>{title}
        </h2>
        <div className="service-para mt-4">
            {children}
        </div>
    </div>
);

const ShippingPolicy = () => {
    return (
        <>
            <Banner heading="Shipping Policy" text="Shipping Policy" />
            <div className="tmp-section-gap">
                <div className="container">

                    {/* Header */}
                    <div className="text-center mb-14 section-head">
                        <div className="section-sub-title center-title">
                            <span className="subtitle">Delivery Information</span>
                        </div>
                        <h2 className="title split-collab mt-2">Our <span style={{ color: '#e74c3c' }}>Delivery</span> Policy</h2>
                        <p className="service-para mt-4 max-w-2xl mx-auto">
                            HNH Soft Tech Solutions delivers 100% digital services. All projects, files, and deliverables are delivered electronically to clients worldwide — including the United States, United Kingdom, and Pakistan.
                        </p>
                        <p className="service-para mt-2 text-sm">
                            Last updated: March 2025
                        </p>
                    </div>

                    {/* Digital Delivery Notice */}
                    <div className="service-card-v2 text-center mb-10" style={{ background: 'rgba(231,76,60,0.08)', border: '1px solid rgba(231,76,60,0.3)' }}>
                        <h2 className="service-card-num mb-2">
                            <span className="text-4xl">🖥️</span>100% Digital Service
                        </h2>
                        <p className="service-para">
                            We are a software & digital agency. We do not ship physical products. All deliverables — websites, apps, design files, source code, reports — are delivered digitally via email, shared drives, or project management platforms.
                        </p>
                    </div>

                    {/* Delivery Methods */}
                    <h3 className="title mb-6 text-center">How Deliverables Are Sent</h3>
                    <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
                        {[
                            { icon: "📧", title: "Email Delivery", desc: "Final files, reports, design assets, and documentation are sent directly to your registered email address." },
                            { icon: "☁️", title: "Cloud Drive", desc: "Large files (source code, media assets, project files) are shared via Google Drive, OneDrive, or Dropbox." },
                            { icon: "🚀", title: "Live Deployment", desc: "Websites and web applications are deployed live to your hosting server or delivered as a deployable package." },
                            { icon: "💻", title: "Git Repositories", desc: "Source code and version control history are securely transferred via GitHub, GitLab, or Bitbucket." },
                        ].map((item, i) => (
                            <InfoCard key={i} icon={item.icon} title={item.title}>
                                <p>{item.desc}</p>
                            </InfoCard>
                        ))}
                    </div>

                    {/* Delivery Timelines */}
                    <div className="service-card-v2 mb-10">
                        <h2 className="service-card-num mb-6">
                            <span className="text-2xl">⏱️</span>Delivery Timelines
                        </h2>
                        <div className="overflow-x-auto">
                            <table className="w-full text-base">
                                <thead>
                                    <tr className="border-b border-gray-200">
                                        <th className="title text-left py-4 pr-4 text-lg">Service Type</th>
                                        <th className="title text-left py-4 pr-4 text-lg">Estimated Delivery</th>
                                        <th className="title text-left py-4 text-lg">Notes</th>
                                    </tr>
                                </thead>
                                <tbody className="divide-y divide-gray-200">
                                    {[
                                        ["Business Consultation / Report", "1–3 business days", "Delivered via email"],
                                        ["UI/UX Design (Mockups)", "3–7 business days", "Via cloud drive link"],
                                        ["Simple Landing Page", "5–10 business days", "Live URL or files delivered"],
                                        ["Full Business Website", "2–4 weeks", "Staged delivery with reviews"],
                                        ["E-Commerce Website", "3–6 weeks", "Milestone-based delivery"],
                                        ["Mobile Application", "6–12 weeks", "Beta + final build delivered"],
                                        ["Custom AI / Software Solution", "8–16 weeks", "Varies by complexity"],
                                        ["SEO / Digital Marketing Reports", "Monthly", "Recurring delivery"],
                                    ].map(([service, time, notes], i) => (
                                        <tr key={i}>
                                            <td className="py-4 pr-4 service-para mt-0 font-medium" style={{ color: 'var(--color-heading)' }}>{service}</td>
                                            <td className="py-4 pr-4 service-para mt-0 text-[#e74c3c] font-semibold">{time}</td>
                                            <td className="py-4 service-para mt-0">{notes}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <p className="service-para mt-4 text-sm">
                            * Timelines begin after receipt of full project requirements, approved design sign-off, and initial deposit payment.
                        </p>
                    </div>

                    {/* Regional Info */}
                    <h3 className="title mb-6 text-center">Service Availability by Region</h3>
                    <div className="grid md:grid-cols-3 gap-6 mb-12">
                        {[
                            {
                                flag: "🇺🇸", country: "United States",
                                address: "3900 West Northwest Highway\nApt 1172, Dallas, TX 75220",
                                phones: ["+1 972 777-4163", "+1 972 707-4985"],
                                hours: "9 AM – 6 PM CST (Mon–Fri)"
                            },
                            {
                                flag: "🇬🇧", country: "United Kingdom",
                                address: "UK registered business\n(Contact us for address)",
                                phones: ["+44 2045 155008", "WhatsApp: +44 7506 100310"],
                                hours: "9 AM – 6 PM GMT (Mon–Fri)"
                            },
                            {
                                flag: "🇵🇰", country: "Pakistan",
                                address: "1E 14/9 Nazimabad karachi, Pakistan\n(Development Hub)",
                                phones: ["+92 340 249 9031"],
                                hours: "1 PM – 9 PM PKT (Mon–Sat)"
                            },
                        ].map((region, i) => (
                            <div key={i} className="service-card-v2 tmponhover text-center p-6 bg-gray-50">
                                <div className="text-3xl mb-3">{region.flag}</div>
                                <h4 className="service-card-num mb-4 text-2xl">{region.country}</h4>
                                <div className="space-y-3 service-para text-sm text-left px-4">
                                    <div>
                                        <span className="service-card-num text-lg" style={{ fontSize: '18px' }}>📍 Address:</span>
                                        <p className="mt-1 whitespace-pre-line">{region.address}</p>
                                    </div>
                                    <div>
                                        <span className="service-card-num text-lg" style={{ fontSize: '18px' }}>📞 Phone:</span>
                                        {region.phones.map((p, pi) => <p key={pi} className="mt-1 mb-0">{p}</p>)}
                                    </div>
                                    <div>
                                        <span className="service-card-num text-lg" style={{ fontSize: '18px' }}>🕐 Hours:</span>
                                        <p className="mt-1 mb-0">{region.hours}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Milestones */}
                    <div className="service-card-v2 mb-10">
                        <h2 className="service-card-num mb-6">
                            <span className="text-2xl">📦</span>Milestone-Based Delivery
                        </h2>
                        <p className="service-para mb-4">
                            For larger projects, we use a milestone-based delivery model to ensure quality at every stage:
                        </p>
                        <div className="relative pl-6 border-l-2 border-[#e74c3c]/40 space-y-6">
                            {[
                                { step: "Kick-off", desc: "Project requirements confirmed, timeline agreed, deposit received" },
                                { step: "Design Delivery", desc: "Wireframes and design mockups shared for your review and approval" },
                                { step: "Development Preview", desc: "Staging/beta version shared for testing and feedback" },
                                { step: "Revisions", desc: "Agreed revisions implemented (typically 2 rounds included)" },
                                { step: "Final Delivery", desc: "Complete source code, live deployment, and documentation delivered" },
                            ].map((m, i) => (
                                <div key={i} className="relative">
                                    <div className="absolute -left-[29px] top-1.5 w-3 h-3 rounded-full bg-[#e74c3c]" />
                                    <h4 className="service-card-num" style={{ fontSize: '20px' }}>Milestone {i + 1}: {m.step}</h4>
                                    <p className="service-para text-sm mt-1">{m.desc}</p>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* CTA */}
                    <div className="service-card-v2 text-center py-10 px-6">
                        <h3 className="service-card-num mb-3">Have a delivery question?</h3>
                        <p className="service-para mb-6">
                            Our project team is available to answer any questions about your delivery timeline.
                        </p>
                        <div className="flex flex-wrap justify-center gap-4">
                            <a href="mailto:info@hnhsofttechsolutions.com" className="tmp-btn btn-primary">Email Us</a>
                            <Link to="/contact" className="tmp-btn border border-gray-300 bg-transparent text-gray-800 hover:bg-gray-100">Contact Page</Link>
                        </div>
                    </div>

                </div>
            </div>
        </>
    );
};

export default ShippingPolicy;
